import type { ReactNode } from "react";

export type StatusTone = "success" | "neutral" | "warning" | "danger";

/** A status pill — the `fawkes-status-badge` vocabulary. Tones map to the semantic tokens. */
export function StatusBadge({ tone = "neutral", children }: { tone?: StatusTone; children: ReactNode }) {
  return <span className={`fui-badge fui-badge--${tone}`}>{children}</span>;
}
